export default __webpack_public_path__ + "static/media/people4small.e58d6b58.jpg";